import { render } from "./mentions-legalesPage.vue?vue&type=template&id=173a7ed5"
import script from "./mentions-legalesPage.vue?vue&type=script&lang=js"
export * from "./mentions-legalesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__